import { useEffect, useState } from 'react';
import { fetchAlgoverseFundsMargin } from 'v3/common/api/algoversePayment';
import { FundsMarginSuccessResponse } from 'v3/pages/PlansAlgoverse/type';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

export const useDeploymentGuard = () => {
  const [isStrategyDeployBlocked, setIsStrategyDeployBlocked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkMargin = async () => {
      try {
        const response: FundsMarginSuccessResponse = await fetchAlgoverseFundsMargin();

        if (response.status === 'success' && response.data) {
          const availableMargin = response.data.equity.available_margin;

          const skipIds = window?.ALGOVERSE_CONFIGS?.skipBillingClientIds || '';
          const brokerId = window.SA_CONFIGS.currentBrokerDetails?.current_broker_client_id;

          setIsStrategyDeployBlocked(availableMargin <= 0 && !skipIds?.split(',').includes(brokerId));
        } else {
          setIsStrategyDeployBlocked(true);
        }
      } catch {
        setIsStrategyDeployBlocked(true);
      } finally {
        setIsLoading(false);
      }
    };

    if (ApplicationDomainUtility.isAlgoverse && window.isUserSignedIn) checkMargin();
    else setIsLoading(false);
  }, []);

  return { isStrategyDeployBlocked, isLoading };
};
